/* Native scrolling, persistent product links, no animation dependency. */
if (!customElements.get('lig-football-cinema')) {
  customElements.define('lig-football-cinema', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.chapters = [...this.querySelectorAll('[data-chapter]')];
      this.links = [...this.querySelectorAll('[data-chapter-link]')];
      this.nav = this.querySelector('.lig-cinema__nav');
      this.track = this.querySelector('.lig-cinema__nav-links');
      this.dock = this.querySelector('.lig-cinema__dock');
      this.header = document.querySelector('header-component');
      this.active = null;
      this.frame = null;
      const options = { signal: this.abort.signal, passive: true };
      this.queue = () => {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.queue, options);
      window.addEventListener('resize', this.queue, options);
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-chapter-link]');
        const chapter = link && this.chapters.find(c => c.dataset.chapter === link.dataset.chapterLink);
        if (chapter) this.setActive(chapter);
      }, { signal: this.abort.signal });
      this.addEventListener('focusin', (event) => {
        const chapter = event.target.closest('[data-chapter]');
        if (chapter) this.setActive(chapter);
      }, { signal: this.abort.signal });
      this.addEventListener('pointerdown', (event) => {
        const chapter = event.target.closest('[data-chapter]');
        if (chapter) this.setActive(chapter);
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const chapter = this.chapters.find(c => c.dataset.chapter === event.detail.blockId);
        if (chapter) { chapter.scrollIntoView({ block: 'start', behavior: 'instant' }); this.setActive(chapter); }
      }, { signal: this.abort.signal });
      this.observer = new ResizeObserver(this.queue);
      this.observer.observe(this);
      if (this.header) this.observer.observe(this.header);
      this.queue();
    }
    setActive(chapter) {
      if (this.active === chapter) return;
      this.active = chapter;
      this.links.forEach(link => {
        if (link.dataset.chapterLink === chapter.dataset.chapter) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      const link = this.links.find(l => l.dataset.chapterLink === chapter.dataset.chapter);
      if (link && this.track) {
        const item = link.getBoundingClientRect(), track = this.track.getBoundingClientRect();
        if (item.left < track.left || item.right > track.right) this.track.scrollLeft += item.left - track.left - 24;
      }
      if (this.dock) {
        const product = chapter.dataset;
        const anchor = this.dock.querySelector('a');
        anchor.href = product.productUrl;
        anchor.setAttribute('aria-label', 'Shop ' + product.productTitle);
        this.dock.querySelector('.lig-cinema__dock-title').textContent = product.productTitle;
        this.dock.querySelector('.lig-cinema__dock-price').textContent = product.productPrice;
        this.dock.querySelector('img').src = product.productImage;
      }
    }
    update() {
      if (!this.chapters.length) return;
      const headerBox = this.header?.getBoundingClientRect();
      const headerBottom = headerBox && headerBox.top <= 0 ? Math.max(0, headerBox.bottom) : 0;
      this.style.setProperty('--cinema-header', `${Math.round(headerBottom)}px`);
      const navHeight = this.nav?.offsetHeight || 0;
      const readingLine = headerBottom + navHeight + (innerHeight - headerBottom - navHeight) * .28;
      const candidates = this.chapters.filter(c => { const r = c.getBoundingClientRect(); return r.top <= readingLine && r.bottom > readingLine; });
      const active = candidates.includes(this.active) ? this.active : candidates[0];
      if (active) this.setActive(active);
      const first = this.chapters[0].getBoundingClientRect();
      const last = this.chapters[this.chapters.length - 1].getBoundingClientRect();
      const start = headerBottom + navHeight;
      const progress = Math.min(1, Math.max(0, (start - first.top) / Math.max(1, last.bottom - first.top - innerHeight + start)));
      this.style.setProperty('--cinema-progress', progress.toFixed(4));
      if (this.dock) {
        const inChapters = Boolean(active) && first.top < innerHeight * .65 && last.bottom > innerHeight * .35;
        const overlayOpen = Boolean(document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]'));
        this.dock.hidden = !inChapters || overlayOpen;
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }
  });
}
